/*
 * Copyright (c) 2023. Henry Zilek
 */

import {createApp} from 'vue'
import App from './App.vue'
import '@/assets/hz_general.css';
import '@/assets/hz_local.css';
import '@/assets/notigo_specific.css';
import HZLink from "@/support/HZLink.vue";
import HZButton from "@/support/HZButton.vue";
import HZBaseButton from "@/support/HZBaseButton.vue";
import router from "@/routes";
import store from "@/store";
import VueCookies from "vue-cookies";
import mitt from 'mitt';
import sup from "@/support/support";

const emitter = mitt();
const Vue = createApp(App);

let handleOutsideClick;
let handleResize;

let resizeTimer;

Vue.directive('closable', {
    beforeMount() {
        handleOutsideClick = (event) => {
            sup.hzLog("Handle outside click")
            if (!isInPopup(event.target)) {
                store.commit('setShowDictionaryPopup', false);
            }
        };

        handleResize = () => {
            sup.hzLog("Screen is resizing")
            store.commit('setWidth', window.innerWidth);
            store.commit('setHeight', window.innerHeight);
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(() => {
                store.commit('setResizeDone', true)
            }, 500)
        }
        // Register click/touchstart event listeners on the whole page
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
        window.addEventListener("resize", handleResize)
    },
    unmounted() {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
        window.removeEventListener('resize', handleResize)
    }

})


Vue.config.globalProperties.emitter = emitter; //Pro pouziti v pripade zachyceni events z jakekoli komponenty
Vue.config.globalProperties.sup = sup; //Support objekt pro uziti ve vsech komponentach

Vue
    .component('HZLink', HZLink)
    .component('HZButton', HZButton)
    .component('hz-base-button', HZBaseButton)
    .use(store)
    .use(router)
    .use(VueCookies, {expires: '7d'})
    .mount('#app');


let baseAdminUrl = null;

// Načtení externího config souboru
fetch(process.env.BASE_URL + "config.json")
    .then((response) => {
        return response.json();
    })
    .then((config) => {
        baseAdminUrl = window.location.origin.includes("localhost") ? config.baseAdminUrl : window.location.origin + "/";
        store.commit('setWidth', window.innerWidth);
        store.commit('setHeight', window.innerHeight);
        store.commit('setApiToken', config.apiToken); // Zápis informací z configuračního souboru do storu
        store.commit('setBaseApiUrl', config.baseApiUrl);
        store.commit('setBaseAdminUrl', baseAdminUrl);
        store.commit('setShopId', config.shopId);
        store.commit('setShopLoc', config.shopLoc);
        store.commit('setStoreUrl', config.storeRefURL);
        store.commit('setRefreshInterval', config.refreshInterval);
        store.commit('setDevelopStatus', config.develop);
        store.commit('setApiKey', config.apiKey); // Zápis informací z configuračního souboru do storu
        store.commit('setApiAuthorization', config.apiAuthorization); // Zápis informací z configuračního souboru do storu
        store.dispatch('watchOnlineStatus');
        sup.hzLog(config);
    }).then(() => {
})

function isInPopup(element) {
    if (element && element.attributes && element.attributes.data_ref) {
        return true;
    }
    if (element && element.localName !== "body") {
        isInPopup(element.parentElement)
    }
    return false;
}

